<template>
  <div class="searchList">
    <div class="box-content">
      <label class="form-tit">订单编号</label>
      <el-input
        v-model="searchData.big_order_no"
        class="jm-input280"/>
    </div>
    <div class="box-content">
      <label class="form-tit">订单名称</label>
      <el-input
        v-model="searchData.title"
        class="jm-input280"/>
    </div>
    <div class="box-content">
      <label class="form-tit">最后付款日期</label>
      <el-date-picker
        class="jm-input280"
        v-model="searchData.last_payment_date"
        type="daterange"
        value-format="yyyy-MM-dd"
        range-separator="-"
        start-placeholder="开始日期"
        end-placeholder="结束日期">
      </el-date-picker>
    </div>
    <div class="box-content">
      <label class="form-tit">是否缴齐</label>
      <jm-dict-select
        class="jm-input280"
        clearable
        v-model="searchData.order_status"
        type="training"
        dict-type="order_status"
        value-type="string"
        name="order_status"/>
    </div>
    <div class="box-content">
      <label class="form-tit">学生姓名</label>
      <el-input
        v-model="searchData.username"
        class="jm-input280"/>
    </div>
    <div class="box-content">
      <label class="form-tit">电话号码</label>
      <el-input
        v-model="searchData.tel"
        class="jm-input280"/>
    </div>
    <div class="box-content">
      <label class="form-tit">创建时间</label>
      <el-date-picker
        class="jm-input280"
        v-model="searchData.create_time"
        type="daterange"
        value-format="yyyy-MM-dd"
        range-separator="-"
        start-placeholder="开始日期"
        end-placeholder="结束日期">
      </el-date-picker>
    </div>
    <div class="box-content">
      <label class="form-tit">学生编码</label>
      <el-input
        v-model="searchData.userid"
        class="jm-input280"/>
    </div>
  </div>
</template>
<script>
function trainingSearchData() {
  return {
    big_order_no: '',
    title: '',
    last_payment_time: [],
    order_status: '',
    username: '',
    tel: '',
    create_time: [],
    userid: '',
    site_name: 'training'
  };
}
export default {
  props: {
    searchData: {
      type: Object,
      default: trainingSearchData(),
    },
  },
  data() {
    return {
      classes: []
    };
  },
  methods: {
    trainingInitSearchData() {
      return trainingSearchData();
    }
  },
  components: {
  },
  mounted() {
  },
  watch: {
    searchData: {
      handler: function (newValue) {
        this.$emit('update:searchData', newValue);
      },
      deep: true
    }
  }
};
</script>
